import { render } from "./CustomerList.vue?vue&type=template&id=8d34a3a4&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"

import "./CustomerList.vue?vue&type=style&index=0&id=8d34a3a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d34a3a4"],['__file',"src/views/h5/common/basedata/partner/customer/CustomerList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d34a3a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d34a3a4', __exports__)) {
    api.reload('8d34a3a4', __exports__)
  }
  
  module.hot.accept("./CustomerList.vue?vue&type=template&id=8d34a3a4&scoped=true", () => {
    api.rerender('8d34a3a4', render)
  })

}


export default __exports__